var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { EntitlementState } from './types';
import { QonversionConfigBuilder, LogLevel, UserPropertiesBuilder, } from '@qonversion/web-sdk';
import Qonversion from '@qonversion/web-sdk/sdk/build/Qonversion';
import { InAppPurchaseError, InAppPurchaseErrorType, } from './InAppPurchaseError';
var entitlementsChangeListeners = [];
var DEFAULT_PERMISSION = 'premium-access';
var initialize = function () { return __awaiter(void 0, void 0, void 0, function () {
    var config;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                config = new QonversionConfigBuilder(process.env.REACT_APP_QONVERSION_PRODUCT_KEY)
                    // .setEnvironment(environment)
                    .setLogLevel(LogLevel.Error) // The lower level you set the more logs will be written
                    .setLogTag('iAP') // Will be added to all Qonversion logs.
                    .build();
                return [4 /*yield*/, Qonversion.initialize(config)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
var identifyUser = function (familyId, customerEmail, userId) { return __awaiter(void 0, void 0, void 0, function () {
    var qonversionInstance, properties;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                // @TENANT_BYPASS: Validazione parametri per evitare errori Qonversion con valori null
                if (!familyId || !customerEmail || !userId) {
                    console.warn('Qonversion identifyUser: missing required parameters', {
                        familyId: familyId,
                        customerEmail: customerEmail,
                        userId: userId,
                    });
                    return [2 /*return*/];
                }
                qonversionInstance = Qonversion.getSharedInstance();
                return [4 /*yield*/, qonversionInstance.logout()];
            case 1:
                _a.sent();
                return [4 /*yield*/, qonversionInstance.identify(familyId)];
            case 2:
                _a.sent();
                properties = new UserPropertiesBuilder()
                    .setCustomUserId(familyId)
                    .setEmail(customerEmail)
                    .setCustomUserProperty('buyerUserId', userId)
                    .build();
                qonversionInstance.setUserProperties(properties);
                return [2 /*return*/];
        }
    });
}); };
var sendNewEntitlement = function (entitlementState) {
    entitlementsChangeListeners.forEach(function (entitlementsChangeListener) {
        entitlementsChangeListener(entitlementState);
    });
};
var getEntitlementState = function (entitlement) {
    if (!entitlement) {
        return EntitlementState.unknown;
    }
    if (entitlement === null || entitlement === void 0 ? void 0 : entitlement.active) {
        return EntitlementState.active;
    }
    return EntitlementState.unknown;
};
var checkEntitlements = function () { return __awaiter(void 0, void 0, void 0, function () {
    var entitlements, premiumEntitlement, entitlementState, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, Qonversion.getSharedInstance().getEntitlements()];
            case 1:
                entitlements = _a.sent();
                premiumEntitlement = entitlements.find(function (entitlement) { return entitlement.id === DEFAULT_PERMISSION; });
                entitlementState = getEntitlementState(premiumEntitlement);
                sendNewEntitlement(entitlementState);
                return [2 /*return*/, entitlementState];
            case 2:
                error_1 = _a.sent();
                return [2 /*return*/, Promise.reject(new InAppPurchaseError(InAppPurchaseErrorType.generic, error_1))];
            case 3: return [2 /*return*/];
        }
    });
}); };
var onEntitlementChange = function (listener) {
    var previousEntitlementsChangeListenersLength = entitlementsChangeListeners.length;
    entitlementsChangeListeners.push(listener);
    // qonversionInstance.setEntitlementsUpdateListener({
    //   onEntitlementsUpdated(entitlements: Map<string, Entitlement>) {
    //     listener(getEntitlementState(entitlements.get(DEFAULT_PERMISSION)));
    //   },
    // });
    return function () {
        return entitlementsChangeListeners.splice(previousEntitlementsChangeListenersLength, 1);
    };
};
var logout = function () { return Qonversion.getSharedInstance().logout(); };
var errorManager = function (t, error) {
    if (!(error instanceof InAppPurchaseError)) {
        return;
    }
    if (error.type === InAppPurchaseErrorType.userCanceled) {
        return;
    }
    if (!error.message) {
        return;
    }
    window.alert(error.message);
};
export var InAppPurchase = {
    initialize: initialize,
    onEntitlementChange: onEntitlementChange,
    identifyUser: identifyUser,
    checkEntitlements: checkEntitlements,
    logout: logout,
    errorManager: errorManager,
};
